module.exports = __webpack_public_path__ + "img/TECNOLOGIA-SCROSS-2.7fd1832d.jpg";